export abstract class Communicator {
	protected options: any;
	protected _tokenID: string;
	protected _regulatedMarket: string;
	protected _moneyMode: string;
	protected _realMoney: boolean;
	protected _channel: string;

	constructor() {}

	public abstract ping(...args: any[]): void;

	public abstract init(...args: any[]): void;

	public abstract saveData(...args: any[]): void;
	public abstract requestSavedData(...args: any[]): void;

	public abstract spin(...args: any[]): void;

	public abstract freeSpin(...args: any[]): void;

	public abstract respin(...args: any[]): void;

	public abstract freespin(...args: any[]): void;

	public abstract pick(...args: any[]): void;

	public abstract skippick(...args: any[]): void;

	public abstract avalanche(...args: any[]): void;

	// Api communication.
	public abstract api_balanceUpdate(...args: any[]): void;

	public abstract api_betSizeUpdate(...args: any[]): void;

	public abstract api_gameplayStart(...args: any[]): void;

	public abstract api_gameplayPause(...args: any[]): void;

	public abstract api_playerInformationRecieved(...args: any[]): void;

	public abstract api_gameSetMute(...args: any[]): void;

	public abstract api_winUpdate(...args: any[]): void;

	public abstract api_gamemenuOpen(...args: any[]): void;

	public abstract api_gamemenuClosed(...args: any[]): void;

	public abstract api_autoPlayStarted(...args: any[]): void;

	public abstract api_autoPlayStopped(...args: any[]): void;

	public abstract api_gameRoundCompleted(...args: any[]): void;

	public abstract api_showErrorMessage(...args: any[]): void;

	public set tokenID(value: string) {
		this._tokenID = value;
	}

	public get tokenID(): string {
		return this._tokenID;
	}

	public set regulatedMarket(value: string) {
		this._regulatedMarket = value;
	}

	public get regulatedMarket(): string {
		return this._regulatedMarket;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/logic/Communicator.ts